import { effect, inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { MemberStore } from '@web/service';

const errorStatus = (error: unknown): number | undefined => {
  const e = error as { status?: number; cause?: { status?: number } } | null;
  return e?.status ?? e?.cause?.status;
};

export const memberLoaded: CanMatchFn = async () => {
  const memberStore = inject(MemberStore);
  const router = inject(Router);

  const settled = () => memberStore.member.hasValue() || !!memberStore.member.error();

  if (!settled()) {
    await new Promise<void>(resolve => {
      const ref = effect(() => {
        if (settled()) {
          ref.destroy();
          resolve();
        }
      });
    });
  }

  const error = memberStore.member.error();
  if (error) {
    return router.createUrlTree(['/unhandled-error'], {
      queryParams: { error: errorStatus(error) === 404 ? 'memberDoesNotExist' : 'Unknown' },
    });
  }
  return true;
};
